import * as React from "react";
import DragableCard from "../DragableCard";

const ProposalInfo = ({
  setState,
  data,
  handleChangeFile,
  handleReorder,
  onReorderComplete,
  onRemoveCard,
  onUpload,
  uploads,
  index,
  type,
  standardPages,
  saving,
  readOnly,
}) => {
  return (
    <div className="ProposalInfo">
      <DragableCard
        setState={setState}
        index={index}
        data={data}
        handleChangeFile={handleChangeFile}
        handleReorder={handleReorder}
        onReorderComplete={onReorderComplete}
        onRemoveCard={onRemoveCard}
        onUpload={onUpload}
        uploads={uploads}
        type={type}
        standardPages={standardPages}
        saving={saving}
        readOnly={readOnly}
      />
    </div>
  );
};

export default ProposalInfo;
